// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"a200b898","401":"d0d7ccd9","453":"1407b060","526":"fc39b2b9","562":"12d4b4be","649":"024f6ba4","672":"d30d5c24","825":"c6fec3d5","855":"706eae1c"}[chunkId] + ".chunk.js";
};